/**
 * Relative age, e.g. "just now", "12 min", "3 hr", "2 days" — or, with `compact: true`,
 * the terse form "12m", "3h", "2d" for tight spaces like a fleet-dashboard health card.
 */
export function formatAgeMinutes(min: number, compact = false): string {
  if (compact) {
    if (min < 60) return `${Math.round(min)}m`;
    const hours = Math.round(min / 60);
    if (hours < 24) return `${hours}h`;
    return `${Math.round(hours / 24)}d`;
  }
  if (min < 1) return 'just now';
  if (min < 60) return `${min} min`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} hr`;
  const days = Math.floor(hr / 24);
  return `${days} day${days === 1 ? '' : 's'}`;
}

/** Compact relative age from an ISO timestamp — returns "—" for missing/invalid/future input. */
export function formatAgeFromIso(iso: string): string {
  const ms = Date.now() - new Date(iso).getTime();
  if (!iso || Number.isNaN(ms) || ms < 0) return '—';
  return formatAgeMinutes(Math.floor(ms / 60_000));
}
